// extracted by mini-css-extract-plugin
export default {"teamMember":"MobileMemberRow_teamMember__2IXLO"};